import { Error, errorAlreadyExistEmail, errorDefault, errorEmailDontExist } from './errors';
import { MapData } from './types';


const apiUrl = (process.env.REACT_APP_BACKEND as string) + '/api';

export async function sendForm(data: MapData, setError: (value: Error) => void, token: string) {
  const urls: Record<string, string> = {
    lablife_bfp: 'widget/add-free-lablife-block',
    lablife_4_birth: 'widget/add-free-lablife-4-birth',
    lablife_new_free_4_birth: 'widget/add-new-free-lablife-4-birth',
  }

  try {
    let url = `${apiUrl}/${urls[token]}`;

    const result = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include',
    }).then((response) => {
      if(response.status == 401) {
        setError(errorAlreadyExistEmail);
        return null;
      }
      return response.json()
    });

    if (result && result.data) {
      return result.data;
    } else if(result && result.failed) {
      setError(errorDefault);
    }
  } catch (err) {
    console.log(err);
    setError(errorDefault);
  }
}

export async function getIDP(data: { email: string, token: string }, setError?: (value: Error) => void) {
  const urls: Record<string, string> = {
    lablife_bfp: 'widget/get-free-lablife-block',
    lablife_4_birth: 'widget/get-free-lablife-4-birth',
    lablife_new_free_4_birth: 'widget/get-new-free-lablife-4-birth',
  }

  try {
    const params = Object.entries(data).reduce((acc, next) => `${acc}${next[0]}=${next[1]}&`, '');
    let url = `${apiUrl}/${urls[data.token]}?${params}`;

    const result = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    }).then((response) => {
      if(response.status == 401) {
        setError?.(errorEmailDontExist);
        return null;
      }
      return response.json()
    });

    if (result && result.data) {
      return result.data;
    } else if(result && result.failed) {
      setError?.(errorDefault);
    }
  } catch (err) {
    setError?.(errorDefault);
  }
}

export function addEmailParameter(url: string, email: string) {
  const urlObj = new URL(url);
  const searchParams = urlObj.searchParams;
  searchParams.set('email', email);
  return urlObj.toString();
}

export const getDeviceDetect = () => {
  const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;

  const isMobile =
    /android|webos|iphone|ipod|blackberry|bb|playbook|iemobile|windows phone|kindle|silk|opera mini|wpdesktop/i.test(
      userAgent,
    );

  // Workaround to detect ipads safari with turned on "request desctop version" (turned on by default)
  const isIPadDesktop =
    /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;

  const isTablet = isIPadDesktop || /Tablet|iPad|Nexus 7|Nexus 10|SM-(T|X)\d+|KFAPWI/i.test(userAgent);
  const isIPad = isIPadDesktop || (isTablet && /iPad/i.test(userAgent));

  return { isMobile, isTablet, isIPad };
};
